import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import PropTypesPresenter from '../utils/PropTypesPresenter';
import { emptyValueToDash } from '../utils/values';

const ORIGINAL_MANUALLY = 'original_manually';
const DUPLICATE_MANUALLY = 'duplicate_manually';
const ORIGINAL_AUTOMATICALLY = 'original_automatically';
const DUPLICATE_AUTOMATICALLY = 'duplicate_automatically';

export const DUPLICATE_STATES = [DUPLICATE_MANUALLY, DUPLICATE_AUTOMATICALLY];

export const DUBLICATION_STATES = {
  original_manually: ORIGINAL_MANUALLY,
  duplicate_manually: DUPLICATE_MANUALLY,
  original_automatically: ORIGINAL_AUTOMATICALLY,
  duplicate_automatically: DUPLICATE_AUTOMATICALLY,
};

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    plaidAccountId: PropTypes.string,
    mask: PropTypes.string,
    name: PropTypes.string,
    officialName: PropTypes.string,
    accountSubtype: PropTypes.string,
    accountType: PropTypes.string,
    originalBankAccount: PropTypes.shape(),
    duplicationState: PropTypes.string,
    ownerAuth0Id: PropTypes.string,
    availableDuplicationStates: PropTypes.arrayOf(PropTypes.string),
    bankAccountsWithMask: PropTypes.arrayOf(PropTypes.shape()),
    integrationItem: PropTypes.shape(),
  },
  {
    hasOriginalBankAccount(bankAccount) {
      return !isNil(this.originalBankAccount(bankAccount));
    },
    ownerAuth0IdReadable(bankAccount) {
      const ownerAuth0Id = this.ownerAuth0Id(bankAccount);

      return emptyValueToDash(ownerAuth0Id);
    },
    isDuplicateManually(bankAccountParams) {
      return (
        bankAccountParams.duplicationState ==
        DUBLICATION_STATES.duplicate_manually
      );
    },
    duplicationStateReadable(bankAccount) {
      switch (this.duplicationState(bankAccount)) {
        case ORIGINAL_MANUALLY:
          return 'Original (manually)';
        case DUPLICATE_MANUALLY:
          return 'Duplicate (manually)';
        case ORIGINAL_AUTOMATICALLY:
          return 'Original (automatically)';
        case DUPLICATE_AUTOMATICALLY:
          return 'Duplicate (automatically)';
      }
    },
    isDisabledDuplicationState(duplicationState) {
      return duplicationState.includes('automatically');
    },
  }
);
